import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-cifris25',
  templateUrl: './home-cifris25.component.html',
  styleUrls: ['./home-cifris25.component.css']
})
export class HomeCifris25Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
